<nz-modal
  [(nzVisible)]="isVisible"
  [nzTitle]="payerData.isBodyCorporate ? 'Corporate Details' : 'Individual Details'"
  [nzFooter]="null"
  [nzWidth]="900"
  (nzOnCancel)="modal.destroy()"
>
  <div class="details-modal-body" *nzModalContent>
    <div class="sidebar">
      <div class="flex-col-12">
        <nz-avatar *ngIf="!payerData.isBodyCorporate" [nzIcon]="'user'" class="avatar"></nz-avatar>
        <nz-avatar *ngIf="payerData.isBodyCorporate" nzSrc="assets/icons/corporate.svg"></nz-avatar>
        <div>
          <div class="name-line">{{ displayName }}</div>
          <div class="email-line">{{ subtitle }}</div>
        </div>
      </div>

      <nz-divider class="divider-tight"/>

      <div>
        <p class="roles-title">Roles</p>
        <div class="roles-wrap">
          <div class="role-item">
            <span class="role-badge" *ngIf="isPayer">Payer</span>
            <span class="role-badge" *ngIf="isRecipient">Recipient</span>
          </div>
        </div>
      </div>
    </div>

    <div class="details-content">
      <nz-tabset>
        <nz-tab nzTitle="General">
          <div class="pad-24">

            <!-- Individual: Personal Details -->
            <ng-container *ngIf="!payerData.isBodyCorporate">
              <div class="mb-2">
                <div class="section-title">Personal Details</div>
                <div class="section-box">
                  <div nz-row class="row dashed">
                    <div nz-col nzSpan="11" class="col-label">Resident or Non-Resident of Kazakhstan</div>
                    <div nz-col nzSpan="13" class="col-value">{{ payerData.isResident ? 'Resident' : 'Non-Resident' }}</div>
                  </div>
                  <div nz-row class="row dashed">
                    <div nz-col nzSpan="11" class="col-label">First name</div>
                    <div nz-col nzSpan="13" class="col-value">{{ payerData.firstName || '—' }}</div>
                  </div>
                  <div nz-row class="row dashed">
                    <div nz-col nzSpan="11" class="col-label">Patronymic name</div>
                    <div nz-col nzSpan="13" class="col-value">{{ payerData.patronymicName || '—' }}</div>
                  </div>
                  <div nz-row class="row">
                    <div nz-col nzSpan="11" class="col-label">Last name</div>
                    <div nz-col nzSpan="13" class="col-value">{{ payerData.lastName || '—' }}</div>
                  </div>
                </div>
              </div>

              <div class="mb-2">
                <div class="section-title">Identity Document</div>
                <div class="section-box">
                  <div nz-row class="row dashed">
                    <div nz-col nzSpan="11" class="col-label">Identity document number</div>
                    <div nz-col nzSpan="13" class="col-value">{{ payerData.identityDocNumber || '—' }}</div>
                  </div>
                  <div nz-row class="row dashed" *ngIf="payerData.isResident">
                    <div nz-col nzSpan="11" class="col-label">IIN</div>
                    <div nz-col nzSpan="13" class="col-value">{{ payerData.iin || '—' }}</div>
                  </div>
                  <div nz-row class="row dashed">
                    <div nz-col nzSpan="11" class="col-label">Country of citizenship</div>
                    <div nz-col nzSpan="13" class="col-value">{{ countryName(payerData.citizenshipCountryId) }}</div>
                  </div>
                  <div nz-row class="row" *ngIf="!payerData.isResident">
                    <div nz-col nzSpan="11" class="col-label">Tax registration number</div>
                    <div nz-col nzSpan="13" class="col-value">{{ payerData.taxNumber || '—' }}</div>
                  </div>
                </div>
              </div>

              <div class="mb-2">
                <div class="section-title">Contact Details</div>
                <div class="section-box">
                  <div nz-row class="row">
                    <div nz-col nzSpan="11" class="col-label">Email</div>
                    <div nz-col nzSpan="13" class="col-value">{{ payerData.email || '—' }}</div>
                  </div>
                </div>
              </div>
            </ng-container>

            <!-- Body Corporate: Company Details -->
            <ng-container *ngIf="payerData.isBodyCorporate">
              <div class="mb-2">
                <div class="section-title">Company Details</div>
                <div class="section-box">
                  <div nz-row class="row dashed">
                    <div nz-col nzSpan="11" class="col-label">Company name</div>
                    <div nz-col nzSpan="13" class="col-value">{{ payerData.companyName || '—' }}</div>
                  </div>
                  <div nz-row class="row dashed">
                    <div nz-col nzSpan="11" class="col-label">Registration Number / BIN</div>
                    <div nz-col nzSpan="13" class="col-value">{{ payerData.registrationNumber || '—' }}</div>
                  </div>
                  <div nz-row class="row">
                    <div nz-col nzSpan="11" class="col-label">Country of incorporation</div>
                    <div nz-col nzSpan="13" class="col-value">{{ countryName(payerData.incorporationCountryId) }}</div>
                  </div>
                </div>
              </div>

              <div class="mb-2">
                <div class="section-title">Contact Details</div>
                <div class="section-box">
                  <div nz-row class="row">
                    <div nz-col nzSpan="11" class="col-label">Email</div>
                    <div nz-col nzSpan="13" class="col-value">{{ payerData.email || '—' }}</div>
                  </div>
                </div>
              </div>
            </ng-container>

            <!-- Address Details (shared) -->
            <div class="mb-2" *ngIf="payerData.addressCountryId || payerData.addressCity">
              <div class="section-title">Address Details</div>
              <div class="section-box">
                <div nz-row class="row dashed">
                  <div nz-col nzSpan="11" class="col-label">Country</div>
                  <div nz-col nzSpan="13" class="col-value">{{ countryName(payerData.addressCountryId) }}</div>
                </div>
                <div nz-row class="row dashed">
                  <div nz-col nzSpan="11" class="col-label">Postal code</div>
                  <div nz-col nzSpan="13" class="col-value">{{ payerData.addressPostalCode || '—' }}</div>
                </div>
                <div nz-row class="row dashed">
                  <div nz-col nzSpan="11" class="col-label">City</div>
                  <div nz-col nzSpan="13" class="col-value">{{ payerData.addressCity || '—' }}</div>
                </div>
                <div nz-row class="row dashed">
                  <div nz-col nzSpan="11" class="col-label">Street</div>
                  <div nz-col nzSpan="13" class="col-value">{{ payerData.addressStreet || '—' }}</div>
                </div>
                <div nz-row class="row dashed">
                  <div nz-col nzSpan="11" class="col-label">Building number</div>
                  <div nz-col nzSpan="13" class="col-value">{{ payerData.addressBuilding || '—' }}</div>
                </div>
                <div nz-row class="row">
                  <div nz-col nzSpan="11" class="col-label">Office/Flat</div>
                  <div nz-col nzSpan="13" class="col-value">{{ payerData.addressOffice || '—' }}</div>
                </div>
              </div>
            </div>

          </div>
        </nz-tab>
        <nz-tab nzTitle="Documents">
          <div class="document-list">
            <div *ngIf="payerData.identityDocs && payerData.identityDocs.length > 0">
              <div class="document-group-title"><span>Identity Documents</span></div>
              <div class="document-item" *ngFor="let doc of payerData.identityDocs">
                <div class="document-info">
                  <i nz-icon [nzType]="'paper-clip'" class="document-icon"></i>
                  <a class="document-link" (click)="previewFile(doc)">{{ doc.fileName }}</a>
                </div>
              </div>
            </div>
            <div *ngIf="payerData.certificateDocs && payerData.certificateDocs.length > 0">
              <div class="document-group-title"><span>Certificate of Incorporation</span></div>
              <div class="document-item" *ngFor="let doc of payerData.certificateDocs">
                <div class="document-info">
                  <i nz-icon [nzType]="'paper-clip'" class="document-icon"></i>
                  <a class="document-link" (click)="previewFile(doc)">{{ doc.fileName }}</a>
                </div>
              </div>
            </div>
            <div *ngIf="!hasDocuments">
              <span class="col-label">No documents available</span>
            </div>
          </div>
        </nz-tab>
      </nz-tabset>
    </div>
  </div>
</nz-modal>
